import Vue from 'vue'

const state = Vue.observable({ isActive: false, contextSelection: { isActive: false } })

export default {
  mounted () {
    this.$watch(() => state.isActive, isActive => {
      isActive ? document.body.classList.add('is-noscroll--lg-down') : document.body.classList.remove('is-noscroll--lg-down')
    }, { immediate: true })
  },

  computed: {
    isMenuOpen () {
      return state.isActive
    },

    contextSelection () {
      return state.contextSelection
    }
  },

  methods: {
    openMenu () {
      state.isActive = true

      this.$nextTick(() => {
        document.querySelector('.c-sidenav').scrollTop = 0
      })
    },

    closeMenu () {
      state.isActive = false
    },

    toggle () {
      state.isActive ? this.closeMenu() : this.openMenu()
    },

    setContextSelectState (data) {
      state.contextSelection = data
    }
  }
}
